import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatEventStatus(status: string): string {
  const statusMap: Record<string, string> = {
    'nowa': 'Nowa',
    'W trakcie': 'W trakcie',
    'w_trakcie': 'W trakcie',
    'potwierdzona': 'Potwierdzona',
    'zakonczona': 'Zakończona',
    'anulowana': 'Anulowana'
  }
  return statusMap[status] || status
}

/**
 * Zwraca poprawną odmianę słowa "danie" w zależności od liczby
 * @param count - liczba dań
 * @returns "danie" (1), "dania" (2-4, 22-24, 32-34, ...), "dań" (0, 5-21, 25-31, ...)
 */
export function pluralizeDish(count: number): string {
  const mod10 = count % 10
  const mod100 = count % 100
  
  // 1, 21, 31, 41, ... → "danie" (ale nie 11, 111, ...)
  if (mod10 === 1 && mod100 !== 11) {
    return 'danie'
  }
  
  // 2-4, 22-24, 32-34, ... → "dania" (ale nie 12-14, 112-114, ...)
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) {
    return 'dania'
  }
  
  // 0, 5-21, 25-31, ... → "dań"
  return 'dań'
}

